// extracted by mini-css-extract-plugin
module.exports = {"offcanvas":"offcanvas_offcanvas__wmwcd","slide":"offcanvas_slide__rtbmM","meimg":"offcanvas_meimg__hmts1"};